import { createContext } from 'react';

type ReCaptchaContextType = {
  isLoaded: boolean;
  sitekey: string;
  scoredBasedKey: string;
};

const ReCaptchaContext = createContext<ReCaptchaContextType>({
  isLoaded: false,
  sitekey: '',
  scoredBasedKey: '',
});

ReCaptchaContext.displayName = 'ReCaptchaContext';

export default ReCaptchaContext;
